import { getFontWeight } from "./design-system";
/**
 * Retrieve the focusOutlineWidth from the design system
 */
function weight(index) {
    return (designSystem) => {
        return getFontWeight(designSystem)[index].toString();
    };
}
function applyFontWeight(weightResolver) {
    return { "font-weight": weightResolver };
}
export function applyFontWeightLight() {
    return applyFontWeight(weight("light"));
}
export function applyFontWeightSemiLight() {
    return applyFontWeight(weight("semilight"));
}
export function applyFontWeightNormal() {
    return applyFontWeight(weight("normal"));
}
export function applyFontWeightSemiBold() {
    return applyFontWeight(weight("semibold"));
}
export function applyFontWeightBold() {
    return applyFontWeight(weight("bold"));
}
